import axios from "../../rest.config";

import { UpdatePasswordI, Credentials, SignupCredentials } from 'vue/types/vue';
import { AxiosResponse } from 'axios';

export class UserServicesImpl {

    async userSignup(payload: SignupCredentials) {

        try {

            const auth = await axios().post("/api/v1/open/user/signup", payload);
            return auth;
        }
        catch (error: any) {
            if (error.response.status === 400) {
                return error.response;
            }
            else {
                throw error.response;
            }
        }
    }
    async userLogin(payload: Credentials) {
        const auth = await axios().post("/api/v1/open/user/login", payload);
        return auth;
    }

    async userLogout() {
        try {

            const status = await axios().get("/api/v1/open/user/logout");
            return status;
        }
        catch (error: any) {
            console.log("errorLogout", error);
        }
    }


    async getUserStatus() {
        const status = await axios().get("/api/v1/open/user/status");

        return status;
    }

    async deletePuzzle() {

    }

    async updatePassword(payload: UpdatePasswordI): Promise<AxiosResponse> {
        try {

            const response: AxiosResponse = await axios().put("/api/v1/user/update/pass", payload);
            return response;
        }
        catch (error: any) {
            const status = error.response.status;
            if (status === 400 || status === 403) {
                return error.response;
            }
            else {
                throw error;
            }

        }
    }

    async deleteUser(): Promise<AxiosResponse> {

        try {
            const response: AxiosResponse = await axios().delete("/api/v1/user/delete/self");
            return response;
        }
        catch (error: any) {
            const status = error.response.status;
            if (status === 400 || status === 403) {
                return error.response;
            }
            else {
                throw error;
            }
        }

    }
}


export const UserService = new UserServicesImpl();